module.exports = __webpack_public_path__ + "img/miles.94d1fe11.png";